/**
 * 서명 picker 메뉴 — 작성기 푸터의 서명 아이콘 클릭 시 열림.
 *
 *   ┌──────────────────────┐
 *   │  내 서명 1            │
 *   │  내 서명 2 (기본)      │
 *   │  내 서명 3            │
 *   │  ─────────────        │
 *   │  📁 보관함             │
 *   │  ⚙ 서명 설정           │
 *   └──────────────────────┘
 */
import React from "react";
import { Box, Divider, ListItemIcon, ListItemText, Menu, MenuItem, Typography } from "@mui/material";
import EditNoteRoundedIcon       from "@mui/icons-material/EditNoteRounded";
import FolderOpenRoundedIcon     from "@mui/icons-material/FolderOpenRounded";
import SettingsRoundedIcon       from "@mui/icons-material/SettingsRounded";
import StarRoundedIcon           from "@mui/icons-material/StarRounded";

export default function SignaturePickerMenu({
    open, anchorEl, onClose,
    signatures = [],
    onPick, onOpenGallery, onOpenEditor,
}) {
    return (
        <Menu
            open={open}
            anchorEl={anchorEl}
            onClose={onClose}
            anchorOrigin={{ vertical: "top", horizontal: "left" }}
            transformOrigin={{ vertical: "bottom", horizontal: "left" }}
            PaperProps={{ sx: { minWidth: 220, maxWidth: 320, borderRadius: 1.5 } }}
        >
            {signatures.length === 0 && (
                <MenuItem disabled sx={{ fontSize: 12, color: "#94a3b8" }}>
                    저장된 서명이 없습니다
                </MenuItem>
            )}
            {signatures.map((s) => (
                <MenuItem key={s.id} onClick={() => onPick?.(s)} sx={{ fontSize: 13 }}>
                    <ListItemIcon>
                        <EditNoteRoundedIcon sx={{ fontSize: 18, color: "#64748b" }} />
                    </ListItemIcon>
                    <ListItemText
                        primary={s.name || "(이름 없음)"}
                        primaryTypographyProps={{ fontSize: 13, fontWeight: 500, noWrap: true }}
                    />
                    {s.isDefault && (
                        <Box sx={{ display: "inline-flex", alignItems: "center", ml: 1 }}>
                            <StarRoundedIcon sx={{ fontSize: 14, color: "#f59e0b" }} />
                            <Typography sx={{ fontSize: 10, ml: 0.3, color: "#f59e0b", fontWeight: 700 }}>기본</Typography>
                        </Box>
                    )}
                </MenuItem>
            ))}

            <Divider sx={{ my: 0.5 }} />

            <MenuItem onClick={onOpenGallery} sx={{ fontSize: 13 }}>
                <ListItemIcon><FolderOpenRoundedIcon sx={{ fontSize: 18, color: "#64748b" }} /></ListItemIcon>
                <ListItemText primary="보관함" primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }} />
            </MenuItem>
            <MenuItem onClick={onOpenEditor} sx={{ fontSize: 13 }}>
                <ListItemIcon><SettingsRoundedIcon sx={{ fontSize: 18, color: "#64748b" }} /></ListItemIcon>
                <ListItemText primary="서명 설정" primaryTypographyProps={{ fontSize: 13, fontWeight: 600 }} />
            </MenuItem>
        </Menu>
    );
}
